// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2fOhx","options":"AnswerScale_options__3pHaR","selected":"AnswerScale_selected__3J8dz"};